import { useContext } from "react";
import { API_BASE } from "@/lib/apiClient";
import { BrandingContext } from "@/lib/branding/BrandingContext";
import { DEFAULT_SITE_NAME } from "@/lib/branding/types";
import { resolveBrandingAssetUrl } from "@shared/brandingAssetUrl";

export function useBranding() {
  const { branding, loading, reload } = useContext(BrandingContext);
  const siteName = branding?.site_name?.trim() || DEFAULT_SITE_NAME;
  const logoUrl = resolveBrandingAssetUrl(branding?.logo_url, API_BASE);
  const faviconUrl = resolveBrandingAssetUrl(branding?.favicon_url, API_BASE) ?? logoUrl;
  return { branding, loading, reload, siteName, logoUrl, faviconUrl };
}
